import React from 'react';
import {
  View, ViewPropTypes, TouchableWithoutFeedback, Text,
  Pressable
} from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import { LightThemeColors } from '../Themes';
import VFText from '../VFText';

import styles from './SectionHeader.Styles';

function SectionHeader({
  theme = LightThemeColors,
  title,
  subtitle,
  illustrationImage,
  style,
  titleStyle,
  subtitleStyle,
  illustrationImageStyle,
  rightText,
  rightTextStyle,
  rightIcon,
  rightIconSize,
  onRightSectionPress = () => null,
  titleAccessbilityLabel,
}) {
  return (
    <View style={[styles.container, style]} testID={FoundationTestKeys.sectionHeaderContainer}>
      <View style={styles.header} testID={FoundationTestKeys.sectionHeaderView}>
        <VFText
          i18nKey={title}
          style={[styles.headerSubTitle(theme), titleStyle]}
          testKey={titleAccessbilityLabel ?? FoundationTestKeys.sectionHeaderTitle}
        />
        {(rightText || rightIcon) && (
          <Pressable
            onPress={onRightSectionPress}
            testID={FoundationTestKeys.sectionHeaderTWF}
          >
            <View
              style={styles.headerRightSection}
              testID={FoundationTestKeys.sectionHeaderTWFview}
            >
              {rightText && (
                <VFText
                  i18nKey={rightText}
                  style={[styles.headerRightSectionText(theme), rightTextStyle]}
                  testKey={FoundationTestKeys.sectionHeaderRightText}
                />
              )}
              {rightIcon && (
                <Icon
                  type="image"
                  name={rightIcon}
                  size={rightIconSize}
                  testID={FoundationTestKeys.sectionHeaderRightIcon}
                />
              )}
            </View>
          </Pressable>
        )}
      </View>
      {subtitle ? (
        <VFText
          i18nKey={subtitle}
          style={[styles.headerDescription(theme), subtitleStyle]}
          testKey={FoundationTestKeys.sectionHeaderSubtitleText}
        />
      ) : null}
      {illustrationImage && (
        <Icon
          type="image"
          name={illustrationImage}
          size={283}
          style={[styles.illustrationImage, illustrationImageStyle]}
          testID={FoundationTestKeys.sectionHeaderSubtitleIcon}
        />
      )}
    </View>
  );
}

SectionHeader.defaultProps = {
  rightIconSize: 25,
};

SectionHeader.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  style: Icon.propTypes.style,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  illustrationImage: Icon.propTypes.name,
  titleStyle: TextPropTypes.style,
  subtitleStyle: TextPropTypes.style,
  illustrationImageStyle: ViewPropTypes.style,
  rightText: PropTypes.string,
  rightTextStyle: TextPropTypes.style,
  rightIcon: Icon.propTypes.name,
  rightIconSize: PropTypes.number,
  onRightSectionPress: PropTypes.func,
  titleAccessbilityLabel: PropTypes.string,
};

export default SectionHeader;
